interface ExerciseRouteContext {
  isActiveSession: boolean;
  isZenMode: boolean;
  tutorWhiteboardEnabled: boolean;
  hasRoom: boolean;
}

export function shouldRouteExerciseToTutorWhiteboard({
  isActiveSession,
  isZenMode,
  tutorWhiteboardEnabled,
  hasRoom,
}: ExerciseRouteContext): boolean {
  return isActiveSession && !isZenMode && tutorWhiteboardEnabled && hasRoom;
}
